import { Navigate } from "react-router";

const RootRedirect = () => {
  // This component is only rendered when user is authenticated (inside RequiredAuth)
  // So we can safely redirect to dashboard
  return <Navigate to="/dashboard" replace />;
};

export default RootRedirect;

